// Note: #previously-marked-as-dead, still used extensively only by LarvaCachedEvent.
// We can probably merge this with LarvaCachedEvent, but too much work for little gain.
import $ from "jquery";
import { isMobile, getPlatform, UniqueId } from 'shared/vidio_helpers';
import AhoyTracker from 'shared/ahoy_tracker';
const tmpl = require('blueimp-tmpl');

export default class LateralEvent {
  constructor(recoId, userId = undefined) {
    this.recoId      = recoId;
    this.userId      = userId;
    this._templateId = 'reco_lateral_tpl';
    this._videoId    = undefined;
  }

  render(recommendations) {
    if(recommendations.length > 0) {
      var data     = { products: recommendations };
      var template = this.renderTemplate(this._templateId, data);
      var $output = $(template);

      var $firstItem = $output.eq(0);
      var $remainingItems = $output.not(':first-child');
      $("#reco_gravity").empty();
      $("#reco_gravity").append($firstItem);

      if(window.native_ads_content) {
        var li = document.createElement('li');
        li.id = 'native_related_ad_container'
        li.className = 'hidden'
        li.appendChild(window.native_ads_content.content)
        $("#reco_gravity").append(li);
      }

      $("#reco_gravity").append($remainingItems);
    }
  }

  renderTemplate(templateId, data) {
    return tmpl(templateId, data);
  }

  modifyData(recommendations) {
    for(var i=0; i<recommendations.length; i++) {
      recommendations[i].length = secondToMinutes(recommendations[i].length);
      recommendations[i].hidePlayCount = false;
      recommendations[i].recommendationLabel = "";
      recommendations[i].Url = recommendations[i].Url.replace(/^.*\/\/[^\/]+/, '');

      if (recommendations[i].recommendation_type === 'user') {
        recommendations[i].hidePlayCount = true;
        recommendations[i].recommendationLabel = "Direkomendasikan";
      }
    }
    return recommendations;
  }

  hidePlayCount() {
    $("#reco_gravity span.video-plays-count[data-hide-play-count=true]").hide();
    $("#reco_gravity span.video-recommendation-reason[data-show-label=true]").removeAttr('style');
  }

  recommendationCallback(response) {
    var uuid = UniqueId.get();
    var recoName = this.recoName();
    var recommendations = null;

    this.keepId(uuid);

    recommendations = response.items;

    if (recommendations.length == 0) {
      if (isMobile()) {
        document.querySelector('#section-related-videos').classList.add('hide');
      } else {
        document.querySelector('.related').classList.add('hide');
      }
    } else {
      let modifiedData = this.modifyData(recommendations);
      this.render(modifiedData);
    }

    this.initAhoy(document.querySelector("#reco_gravity"));

    $('#reco_gravity').css('display', 'block');
    $('#reco_header').css('display', 'block');
    $('#reco_gravity_more').css('display', 'block');

    this.hidePlayCount();

    if (this.isFallback(recommendations)) {
      recoName = this.fallbackName();
    }

    $("#reco_gravity").attr("data-recommender-name", recoName);
    this.sendPlentyEvent(this._videoId, uuid, recommendations);
    window.PlayerState = response;

    if (isMobile() && this.unobserve != null) {
      this.unobserve(document.querySelector('#section-related-videos'));
    }
  }

  parseHtmlToRecommendation(response) {
    var jsonResponse = [];
    $(response).each(function (idx, data) {
      jsonResponse.push({});
      jsonResponse[idx].itemId              = $(data).find("[data-id]").data("id");
      jsonResponse[idx].title               = $(data).find("[data-title]").data("title");
      var textDuration                      = $(data).find(".video-card__duration").text();
      var convertedDuration                 = timeToSeconds(textDuration);
      jsonResponse[idx].length              = convertedDuration;
      jsonResponse[idx].Url                 = $(data).find(".video-card__thumbnail-link").attr("href");
      jsonResponse[idx].user                = $(data).find(".user-name.video-card__caption--username").text();
      jsonResponse[idx].username            = $(data).find(".video-card__user-link").attr("href").slice(2);
      jsonResponse[idx].user_verified       = $(data).find(".user-avatar-role__role.user-avatar-role__role--24").length !== 0;
      jsonResponse[idx].recommendation_type = $(data).find("[data-recommendation-type]").first().data("recommendation-type");
    });
    return jsonResponse;
  }

  getRecommendations() {
    throw new TypeError('getRecommendations must be implemeted in subclass');
  }

  recoName() {
    throw new TypeError('recoName must be implemeted in subclass');
  }

  fallbackName() {
    throw new TypeError('fallbackName must be implemeted in subclass');
  }

  keepId(uuid) {
    $("#reco_gravity").attr('data-recommendation-uuid', uuid);
  }

  isFallback(recommendations) {
    if (recommendations.length === 0) return false;

    if (recommendations[0].recommendation_type === 'popular') {
      return true;
    } else {
      return false;
    }
  }

  getProperties(videoId, uuid, recommendations) {
    var login       = $("#reco_gravity").attr('data-login');
    var platform    = getPlatform();
    var recommender = this.isFallback(recommendations) ? this.fallbackName() : this.recoName();

    return {
      uuid:            uuid,
      recommendations: recommendations,
      app_name:        'vidio',
      recommender:     recommender,
      login:           login,
      platform:        platform,
      video_id:        videoId,
      page_name:       'watch'
    };
  }

  sendPlentyEvent(videoId, uuid, recommendations) {
    var properties = this.getProperties(videoId, uuid, recommendations);
    ahoy.track('RECOMMENDATION::GET', properties);
  }

  get templateId() {
    return this._templateId;
  }

  get videoId() {
    return this._videoId;
  }

  viewVideo(videoId) {
    this._videoId = videoId;
    this.adjustSidebarVisibility();
  }

  adjustSidebarVisibility() {
    $('#playlist-container').removeClass('hide-me');
  }

  bindEventRecClick() {
    return true;
  }

  getScenarioId() {
    return true;
  }

  sendRelatedEvent() {
    return true;
  }

  initAhoy(el) {
    let elements = Array.prototype.slice.call(el.getElementsByClassName('js-ahoy'));

    for(var i = 0; i < elements.length; i++) {
      let element = elements[i];
      var ahoy_tracker = new AhoyTracker(element);
      ahoy_tracker.init();
    }
  }
}

// static functions
function secondToMinutes(second) {
    var sec_num = parseInt(second, 10);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (hours == '00')
      hours = '';
    else
      hours = hours + ':';

    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    var time    = hours+minutes+':'+seconds;
    return time;
}

function timeToSeconds(timeString) {
  var timeArray = timeString.split(':');
  var timeMultiplier = [3600, 60, 1];

  var temp;
  var result = 0;
  var tempNumber;
  temp = timeArray.pop();
  while(temp !== undefined) {
    tempNumber = parseInt(temp);
    result += tempNumber * timeMultiplier.pop();
    temp = timeArray.pop();
  }

  return result;
}
